/** @jsx h */
import { h } from "hyperapp";
import classNames from "classnames";
import { Fragment, WrappedSvg } from "../../utilities/hyperapp";
import AddToQueueButton from "./add-to-queue-button";

import playIcon from "!svg-inline-loader?removeSVGTagAttrs=false!../../player/play-icon.svg";
import pauseIcon from "!svg-inline-loader?removeSVGTagAttrs=false!../../player/pause-icon.svg";

export default function PlayerButtons({
  addToQueue,
  isPlaying,
  pause,
  play,
  size,
  items
}) {
  const item = items[0];
  return (
    <Fragment>
      <button
        class={classNames("action", `action--${size}`, "action--play", {
          "action--play-active": isPlaying
        })}
        aria-label={isPlaying ? "Pause" : "Play"}
        onclick={isPlaying ? pause : play}
        ga-on="click,auxclick,contextmenu"
        ga-event-category="audio"
        ga-event-action={isPlaying ? "pause" : "play"}
        ga-event-label={item.data.title}
      >
        <span class="play-button">
          <WrappedSvg data={playIcon} />
        </span>
        <span class="pause-button">
          <WrappedSvg data={pauseIcon} />
        </span>
      </button>
      <AddToQueueButton addToQueue={addToQueue} size={size} item={item} />
    </Fragment>
  );
}
